module.exports = __webpack_public_path__ + "img/confirm_green.020fff05.svg";